import $ from "jquery";

// https://blogs.perficientdigital.com/2017/11/21/detecting-the-use-of-a-touch-screen/
// Set variable to cache the results of isTouch
let _isTouchCached = null;
// Set a variable detecting the existence of touch events
let _hasEvents = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
// Set a flag variable to keep track of if the mouse/touch event listeners were already added
let _listenersAdded = false;
// Call the isTouch method initially

// The function to add the mouse/touch event listeners
function _addListeners() {
    if (!_listenersAdded) {
        window.addEventListener('mousemove', _checkForMouse);
        window.addEventListener('touchstart', _checkForTouch);
    }
    _listenersAdded = true;
}

// The mouse event listener
function _checkForMouse() {
    _isTouchCached = false;
    _removeListeners();
}

// The touch event listener
function _checkForTouch() {
    utils.logger.log('touch device detected');
    $('html').removeClass('touch-unsafe');
    $('html').addClass('touch-safe');
    _isTouchCached = true;
    _removeListeners();
}

// The function to remove the mouse/touch event listeners
function _removeListeners() {
    window.removeEventListener('mousemove', _checkForMouse);
    window.removeEventListener('touchstart', _checkForTouch);
}

const utils = {
    isOnScreen(element) {
        let $this = $(element);
        if ($this.length === 0) return false;
        let viewport = {};
        viewport.top = $(window).scrollTop();
        viewport.bottom = viewport.top + $(window).height();
        let bounds = {};
        bounds.top = $this.offset().top;
        bounds.bottom = bounds.top + $this.outerHeight();
        return ((bounds.bottom <= viewport.bottom) && (bounds.top >= viewport.top));
    },
    isPartiallyOnScreen(element) {
        let $this = $(element);
        if ($this.length === 0) return false;
        let viewport = {};
        viewport.top = $(window).scrollTop();
        viewport.bottom = viewport.top + $(window).height();
        let bounds = {};
        bounds.top = $this.offset().top;
        bounds.bottom = bounds.top + $this.outerHeight();
        return (((bounds.bottom > viewport.top) && (bounds.top < viewport.bottom)) || ((bounds.top < viewport.bottom) && (bounds.bottom > viewport.top)));
    },
    logger: {
        log(msg) {
            if (ACC.config.debugLoggingEnabled) {
                console.log(msg);
            }
        },
        debug(msg) {
            if (ACC.config.debugLoggingEnabled) {
                console.debug(msg);
            }
        },
        error(msg) {
            console.error(msg);
        },
        info(msg) {
            console.info(msg);
        }
    },
    isTouch() {
        // If the cached variable already has a value
        if (_isTouchCached !== null) {
            // Just return the cached variable and don't bother checking again
            return _isTouchCached;
        }
        // If the browser supports touch events
        if (_hasEvents) {
            $('html').addClass('touch-unsafe');
            // If the mouse/touch event listeners haven't been added yet
            if (!_listenersAdded) {
                // Add the mouse/touch event listeners
                _addListeners();
            }
            // If the browser doesn't support touch events
        } else {
            // Set the cached variable to false
            _isTouchCached = false;
        }
        // Return the current value of the cached variable
        return _isTouchCached;
    },
    createOverlay() {
        $('body').append(`
            <div id="js-overlay" class="c-overlay">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="c-overlay__spinner">
                    <g transform="translate(50 50)">
                        <path fill="currentColor"
                              d="M40.7-34.3c-9.8-9.8-25.6-9.8-35.4,0L0-29l-5.3-5.3c-9.8-9.8-25.6-9.8-35.4,0l0,0c-9.8,9.8-9.8,25.6,0,35.4l5.3,5.3L-23,18.7l23,23l23-23L35.4,6.3L40.7,1C50.4-8.8,50.4-24.6,40.7-34.3z">
                            <animateTransform attributeName="transform" type="scale" calcMode="spline"
                                              values="0.85;1;0.75;0.9;0.85;0.8" keyTimes="0;0.05;0.39;0.45;0.6;1" dur="1s"
                                              keySplines="0.215 0.61,0.355 1;0.215 0.61,0.355 1;0.215 0.61,0.355 1;0.215 0.61,0.355 1;0.215 0.61,0.355 1"
                                              begin="0s"
                                              repeatCount="indefinite">
                            </animateTransform>
                        </path>
                    </g>
                </svg>
            </div>
        `);
    },
    showOverlay() {
        document.querySelector('#js-overlay').classList.add('c-overlay--visible');
    },
    hideOverlay() {
        document.querySelector('#js-overlay').classList.remove('c-overlay--visible');
    },
    isIOS() {
        let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (isIOS) {
            $('html').addClass('ios');
            utils.logger.log('isIOS');
        }
    },
    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2){
            return parts.pop().split(';').shift();
        }
    }
};

(function () {
    // Call the isTouch method initially
    utils.isTouch();
    utils.createOverlay();
    utils.isIOS();
})();


export default utils;
